import { render, staticRenderFns } from "./compose-dialog.vue?vue&type=template&id=d4ff9778&"
import script from "./compose-dialog.vue?vue&type=script&lang=js&"
export * from "./compose-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports